import { HttpEvent, HttpEventType, HttpResponse } from "@angular/common/http";
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  NgbModal,
  NgbModalRef,
  NgbProgressbarConfig,
} from "@ng-bootstrap/ng-bootstrap";
import { select, Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { map, Observable, of, Subject, takeUntil } from "rxjs";
import { ObjectiveTypeEnum } from "src/app/shared/enum/objectives";
import { UserHistoryActionsEnum } from "src/app/shared/enum/userHistoryActions";
import { UserHistoryServicesEnum } from "src/app/shared/enum/userHistoryService";
import {
  AdvertisingCampaignInterface,
  CreateUpdateAdvertisingCampaignInterface,
  DatesAndLocationsAvailabilities,
  LastAvailabilityUpdates,
  LocationWithAvailabilities,
} from "src/app/shared/models/advertising-campaigns/advertising-campaign.interface";
import { SuccessDto } from "src/app/shared/models/success-dto";
import { NewCampaignCalculatorService } from "src/app/shared/services/calculations/new-campaign.service";
import { ExtensionService } from "src/app/shared/services/extension/extension.service";
import { SaveUserHistoryService } from "src/app/shared/services/history/saveHistory";
import { updateAdCampaignDetailsSelector } from "src/app/store/advertisingCampaign/advertiserCampaign.selectors";
import {
  invokeUpdateAdCampaignDetails,
  updateAdCampaignDetails,
} from "src/app/store/advertisingCampaign/advertisingCampaign.actions";
import { AppStateInterface } from "src/app/store/appState.interface";
import {
  invokeUploadFileWithProgress,
  setFileName,
} from "src/app/store/file/file.actions";
import { uploadFileProgressSelector } from "src/app/store/file/file.selectors";
import {
  catchForbiddenError,
  catchServerError,
} from "src/app/store/user/user.actions";
import {
  catchForbiddenErrorSelector,
  catchServerErrorSelector,
} from "src/app/store/user/user.selectors";
import { calculateTotalLPPriceByCampanyNamesSelector } from "src/app/store/locationPartner/location-partner.selectors";
import { environment } from "src/environments/environment";
import {
  LocationAvailabilityEnum,
  SUSPENDED_LOCATION_AVAILABILITIES,
} from "src/app/shared/enum/location-availability";
import { BadgeService } from "src/app/shared/services/badge.service";
import { CalculatePrice } from "src/app/shared/models/calcul/calculatePrice";
import { LocationPartnersService } from "src/app/shared/services/location-partners.service";
import { ListLocationPartnerAvailabilitiesComponent } from "src/app/shared/components/locationPartnerAvailabilityManager/list-location-partner-availabilities/list-location-partner-availabilities.component";
import { DateFilter } from "src/app/shared/models/date-filte.interface";
import { Constants } from "src/app/shared/data/constants";
import { UtilFunctions } from "src/app/utils/utilFunctions";
import {
  calculateTotalLPPriceByCampanyNames,
  selectedLPs,
} from "src/app/store/locationPartner/location-partner.action";
import {
  TotalPrice,
  TotalPriceWithDiscount,
} from "src/app/shared/models/calcul/totalPrice";

@Component({
  selector: "app-update-campaign",
  templateUrl: "./update-campaign.component.html",
  styleUrls: ["./update-campaign.component.scss"],
})
export class UpdateCampaignComponent implements OnInit, OnDestroy {
  form: FormGroup;
  @Input() ad: AdvertisingCampaignInterface;
  showProgress: boolean = false;
  uploadProgress: number = 0;
  files: File[] = [];
  showError: boolean = false;
  filename: string | null = null;
  uploadFile$: Observable<HttpEvent<any> | null | HttpResponse<any>>;
  update$: Observable<SuccessDto | null>;

  objectiveEnum = ObjectiveTypeEnum;

  loading: boolean = false;
  catchServerError$: Observable<boolean | null>;

  ngDestroyed$: Subject<void> = new Subject<void>();
  catchForbiddenError$: Observable<boolean | null>;
  @Output() confirmAction: EventEmitter<boolean> = new EventEmitter();

  isUpdateTotalHT: boolean = false;
  calculateTotalLPPriceByCompanyNames$: Observable<TotalPriceWithDiscount | null>;
  totalPriceWithDiscount: TotalPriceWithDiscount;
  originalLocationsWithAvailabilities: LocationWithAvailabilities[] = [];
  locationsWithAvailabilities: LocationWithAvailabilities[] = [];
  originalStartDateReference: Date;
  originalEndDateReference: Date;
  preservedStartDateBoundary: Date;
  preservedEndDateBoundary: Date;

  totalPricePerDay: TotalPrice[] = [];

  isModalOpen: boolean = true;

  endDate: Date;

  startDate: Date;

  lastEndDateChosen: Date;

  today: Date = new Date(new Date().setHours(0, 0, 0, 0));
  discount: number;

  lastStartDateChosen: Date;

  locationAvailabilityEnum = LocationAvailabilityEnum;

  @Output() emitLocationWithAvailabilities =
    new EventEmitter<DatesAndLocationsAvailabilities>();
  constructor(
    private fb: FormBuilder,
    private store: Store<AppStateInterface>,
    private modalService: NgbModal,
    private extensionService: ExtensionService,
    private translate: TranslateService,
    private saveHistory: SaveUserHistoryService,
    configPB: NgbProgressbarConfig,
    public newCampaignCalculatorService: NewCampaignCalculatorService,
    public badgeService: BadgeService,
    private locationPartnerService: LocationPartnersService
  ) {
    configPB.max = 100;
    configPB.striped = true;
    configPB.animated = true;
    configPB.type = "primary";
    configPB.height = "20px";
    this.form = fb.group({
      redirectionLink: [null],
      startDate: [null, [Validators.required]],
      endDate: [null, [Validators.required]],
      formId: [null],
    });
    this.calculateTotalLPPriceByCompanyNames$ = this.store
      .pipe(select(calculateTotalLPPriceByCampanyNamesSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.update$ = this.store
      .pipe(select(updateAdCampaignDetailsSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.uploadFile$ = this.store
      .pipe(select(uploadFileProgressSelector))
      .pipe(takeUntil(this.ngDestroyed$));

    this.catchServerError$ = this.store
      .pipe(select(catchServerErrorSelector))
      .pipe(takeUntil(this.ngDestroyed$));

    this.catchForbiddenError$ = this.store
      .pipe(select(catchForbiddenErrorSelector))
      .pipe(takeUntil(this.ngDestroyed$));
  }
  ngOnDestroy(): void {
    this.ngDestroyed$.next();
    this.ngDestroyed$.unsubscribe();
  }
  private loadImage(): Observable<Blob> {
    return of(environment.CDN_RELEAD + this.ad.videoLink).pipe(
      map((data) => {
        const blob = new Blob([data], {
          type: `video/${this.extensionService.getExtension(
            this.ad.videoLink
          )}`,
        });
        return blob;
      })
    );
  }
  ngOnInit(): void {
    this.store.dispatch(selectedLPs({ selectedLps: null }));
    this.store.dispatch(
      calculateTotalLPPriceByCampanyNames({ totalPriceWithDiscount: null })
    );
    this.initializeCampaignAvailabilityState();
    this.subscribeToForbiddenErrors();
    this.patchInitialFormValues();
    this.requestInitialAvailabilityStatuses();
    this.subscribeToCalculatedPrices();
    this.subscribeToServerErrors();
    this.initializeExistingVideoFile();
    this.subscribeToUploadProgress();
    this.subscribeToUpdateResult();
  }

  calculateTotalPrice(): number {
    let totalPrices: number = 0;
    this.locationsWithAvailabilities.forEach((location) => {
      const totalPricePerDayPerLp = this.totalPricePerDay.find(
        (lp) => lp.companyName === location.companyName
      );
      if (totalPricePerDayPerLp) {
        let totalDaysForLocation = 0;

        location.listOfAvailableDates.forEach((availableDates) => {
          const days = this.newCampaignCalculatorService.calculateDays(
            availableDates.startDate,
            availableDates.endDate
          );
          totalDaysForLocation += days;
        });
        const totalPriceForThisLocation =
          this.newCampaignCalculatorService.calculateTotalPricePerLocation(
            totalPricePerDayPerLp,
            this.totalPriceWithDiscount.discount,
            totalDaysForLocation
          );

        totalPrices += totalPriceForThisLocation;
      }
    });
    return totalPrices;
  }

  private requestInitialAvailabilityStatuses(): void {
    if (!this.ad?.locationPartners?.length) {
      return;
    }

    this.newCampaignCalculatorService.onSelectCalculatePrice(
      this.startDate,
      this.endDate,
      this.ad.objectiveName,
      this.ad.calculationMethod,
      this.ad.locationPartners
    );
  }

  listLocationsWithAvailabilities(
    listOfAvailableDates: DateFilter[],
    companyName: string
  ) {
    this.updateOriginalLocationAndRefresh(
      this.createLocationWithAvailabilities(companyName, listOfAvailableDates)
    );
  }

  emitDatesAndAvailabilities(
    locationsWithAvailabilities: LocationWithAvailabilities[]
  ) {
    const clonedLocations = this.cloneLocationsWithAvailabilities(
      locationsWithAvailabilities
    );

    this.locationsWithAvailabilities = clonedLocations;

    const datesAndAvailabilities: DatesAndLocationsAvailabilities = {
      startDate: this.cloneDate(this.startDate),
      endDate: this.cloneDate(this.endDate),
      locationWithAvailabilities: clonedLocations,
    };
    this.emitLocationWithAvailabilities.emit(datesAndAvailabilities);
  }
  update() {
    this.confirmAction.emit(true);
    this.loading = true;
    const totalHt = this.isUpdateTotalHT
      ? this.calculateTotalPrice()
      : this.ad.totalHt;
    const adCampaign = this.buildUpdateCampaignPayload(totalHt);

    if (!this.ad.advertisingCampaignHashedId) {
      this.uploadProgress = 0;
      return;
    }

    this.store.dispatch(
      invokeUpdateAdCampaignDetails({
        campaignHashedId: this.ad.advertisingCampaignHashedId,
        adCompaign: adCampaign,
      })
    );
    this.saveHistory.saveUserHistory(
      UserHistoryActionsEnum.PATCH,
      UserHistoryServicesEnum.ADMIN_CAMPAIGN_ADVERTISER_UPDATE
    );
    this.uploadProgress = 0;
  }
  onSelect(event: File[]) {
    this.showProgress = true;
    if (event[0].size > 5242880) {
      this.showError = true;
      this.showProgress = false;
    } else {
      this.files.push(event[0]);
      const formData = new FormData();
      formData.append("file", this.files[0], this.files[0].name);
      this.store.dispatch(invokeUploadFileWithProgress({ file: formData }));
    }
  }
  onRemove() {
    this.files = [];
    this.filename = null;
  }
  close() {
    this.files = [];
    this.modalService.dismissAll();
  }

  onChecked(event: any) {
    this.isUpdateTotalHT = event.target.checked;
    this.locationPartnerService
      .calculateTotalLPPriceByCampanyNames(
        this.buildCalculatePriceRequest(this.startDate, this.endDate, true)
      )
      .subscribe({
        next: (result) => {
          this.discount = result.discount;
          this.totalPricePerDay = result.totalPricePerDay;
          this.totalPriceWithDiscount = result;
        },
      });
  }

  newAvailabilities(newLocationWithAvailabilities: LocationWithAvailabilities) {
    this.updateOriginalLocationAndRefresh(
      this.buildUpdatedLocationAvailabilities(newLocationWithAvailabilities)
    );
  }

  onChangeCheckAvailability() {
    const nextEndDate = this.getDateFromForm("endDate");
    this.endDate = nextEndDate;

    if (this.isEndDateBeyondPreservedBoundary(nextEndDate)) {
      this.calculateNewTotalPriceAndOpenListModal(
        this.getExtendedEndDateStart(),
        nextEndDate
      );
      return;
    }

    this.lastEndDateChosen = nextEndDate;
    this.refreshDisplayedLocationsWithAvailabilities();
  }

  onChangeStartDateCheckAvailability() {
    const nextStartDate = this.getDateFromForm("startDate");
    this.startDate = nextStartDate;

    if (this.isStartDateBeforePreservedBoundary(nextStartDate)) {
      this.calculateNewTotalPriceAndOpenListModal(
        nextStartDate,
        this.getExtendedStartDateEnd()
      );
      return;
    }

    this.lastStartDateChosen = nextStartDate;
    this.refreshDisplayedLocationsWithAvailabilities();
  }

  calculateNewTotalPriceAndOpenListModal(startDate: Date, endDate: Date) {
    if (!this.isModalOpen) {
      return;
    }

    this.locationPartnerService
      .calculateTotalLPPriceByCampanyNames(
        this.buildCalculatePriceRequest(startDate, endDate, false)
      )
      .subscribe({
        next: (result) => {
          this.discount = result.discount;
          this.totalPricePerDay = result.totalPricePerDay;
          this.showListLocationPartnersAvailabilities(
            result.totalPricePerDay,
            startDate,
            endDate
          );
        },
      });
  }
  showListLocationPartnersAvailabilities(
    totalPrice: TotalPrice[],
    startDate: Date,
    endDate: Date
  ) {
    const modal = this.openAvailabilityModal();
    const componentInstance =
      modal.componentInstance as ListLocationPartnerAvailabilitiesComponent;
    const availabilityModalInputs = modal.componentInstance as unknown as {
      locationsWithAvailabilities: LocationWithAvailabilities[];
    };

    componentInstance.totalPrice = totalPrice;
    componentInstance.startDate = startDate;
    componentInstance.endDate = endDate;
    componentInstance.advertisingCampaign = this.ad;
    availabilityModalInputs.locationsWithAvailabilities =
      this.locationsWithAvailabilities;

    componentInstance.emitLocationAvailabilityDto.subscribe(
      (value: LastAvailabilityUpdates) =>
        this.handleAvailabilityModalSave(modal, value)
    );

    componentInstance.cancelAction.subscribe(() =>
      this.handleAvailabilityModalCancel(modal)
    );
  }

  mergeAvailabilitiesWithIntervals(
    value: LocationWithAvailabilities[]
  ): LocationWithAvailabilities[] {
    const mergedLocations = value.reduce(
      (currentLocations, newItem) =>
        this.mergeAvailabilityIntoLocations(currentLocations, newItem),
      this.cloneLocationsWithAvailabilities(
        this.originalLocationsWithAvailabilities
      )
    );

    this.syncOriginalLocationsWithAvailabilities(mergedLocations);
    return mergedLocations;
  }
  mergeOverlappingIntervals(newAvailableDates: DateFilter[]): DateFilter[] {
    if (!newAvailableDates.length) return [];

    const validAvailableDates = newAvailableDates
      .filter((interval) => interval.startDate && interval.endDate)
      .map((interval) => ({
        startDate: new Date(interval.startDate!),
        endDate: new Date(interval.endDate!),
      }))
      .sort((a, b) => a.startDate.getTime() - b.startDate.getTime());
    if (!validAvailableDates.length) return [];

    return validAvailableDates.reduce<DateFilter[]>((merged, current) => {
      const last = merged[merged.length - 1];

      if (!last) {
        return [current];
      }

      if (
        last.endDate &&
        current.startDate.getTime() <= last.endDate.getTime() + Constants.oneDay
      ) {
        return [
          ...merged.slice(0, -1),
          {
            ...last,
            endDate: new Date(
              Math.max(last.endDate.getTime(), current.endDate.getTime())
            ),
          },
        ];
      }

      return [...merged, current];
    }, []);
  }

  latestLocationWithAvailability(newLocations: LocationWithAvailabilities[]) {
    const nextOriginalLocations = newLocations.map((location) =>
      this.createLocationWithAvailabilities(
        location.companyName,
        this.getOriginalLocation(location.companyName)?.listOfAvailableDates ??
          location.listOfAvailableDates
      )
    );

    this.syncOriginalLocationsWithAvailabilities(nextOriginalLocations);
    this.refreshDisplayedLocationsWithAvailabilities();
  }

  isShowWarning(): boolean {
    return this.locationsWithAvailabilities.some((location) => {
      if (this.isSuspendedLocation(location.companyName)) {
        return true;
      }

      const status = UtilFunctions.getAvailabilityStatus(
        location.companyName,
        this.locationsWithAvailabilities,
        this.startDate,
        this.endDate
      );
      return (
        status === LocationAvailabilityEnum.NOT_AVAILABLE ||
        status === LocationAvailabilityEnum.PARTIALLY
      );
    });
  }

  minStartDate(): Date {
    this.today.setHours(0, 0, 0, 0);

    if (!this.ad?.startingDate) {
      return this.today;
    }

    const start = new Date(this.ad.startingDate);
    if (isNaN(start.getTime())) {
      return this.today;
    }

    start.setHours(0, 0, 0, 0);

    return start.getTime() > this.today.getTime() ? this.today : start;
  }

  normalizeDates(date: Date): Date {
    const d = this.cloneDate(date);
    d.setHours(0, 0, 0, 0);
    return d;
  }

  private initializeCampaignAvailabilityState(): void {
    this.originalStartDateReference = this.cloneDate(this.ad.startingDate);
    this.originalEndDateReference = this.cloneDate(this.ad.endingDate);
    this.startDate = this.cloneDate(this.ad.startingDate);
    this.endDate = this.cloneDate(this.ad.endingDate);
    this.lastEndDateChosen = this.cloneDate(this.endDate);
    this.lastStartDateChosen = this.cloneDate(this.startDate);
    this.preservedStartDateBoundary = this.cloneDate(this.startDate);
    this.preservedEndDateBoundary = this.cloneDate(this.endDate);
    this.locationsWithAvailabilities = this.cloneLocationsWithAvailabilities(
      this.ad.locationsWithAvailabilities
    );
    this.syncOriginalLocationsWithAvailabilities(
      this.locationsWithAvailabilities
    );
  }

  private subscribeToForbiddenErrors(): void {
    this.catchForbiddenError$.subscribe((result) => {
      if (!result) {
        return;
      }

      this.loading = false;
      this.modalService.dismissAll();
      this.store.dispatch(catchForbiddenError({ forbiddenError: null }));
    });
  }

  private subscribeToCalculatedPrices(): void {
    this.calculateTotalLPPriceByCompanyNames$.subscribe((value) => {
      if (!value?.totalPricePerDay.length) {
        return;
      }

      this.totalPricePerDay = value.totalPricePerDay;
      this.discount = value.discount;
      this.syncLocationsWithCalculatedPrices(value.totalPricePerDay);
    });
  }

  private syncLocationsWithCalculatedPrices(
    totalPricePerDay: TotalPrice[]
  ): void {
    totalPricePerDay.forEach((location) => {
      if (!this.ad.locationPartners.includes(location.companyName)) {
        this.listLocationsWithAvailabilities(
          this.getAvailableDatesForNonPartner(location),
          location.companyName
        );
        return;
      }

      if (this.hasLocationWithAvailabilities(location.companyName)) {
        return;
      }

      const availability = this.ad.locationsWithAvailabilities.find(
        (lp) => lp.companyName === location.companyName
      );

      if (!availability) {
        return;
      }

      this.listLocationsWithAvailabilities(
        availability.listOfAvailableDates,
        availability.companyName
      );
    });
  }

  private getAvailableDatesForNonPartner(location: TotalPrice): DateFilter[] {
    const status = location.availabilities.availabilityStatus;
    return status === LocationAvailabilityEnum.NOT_AVAILABLE ||
      SUSPENDED_LOCATION_AVAILABILITIES.includes(status)
      ? []
      : location.availabilities.listOfUnpaidBookingIntervals;
  }

  private isSuspendedLocation(companyName: string): boolean {
    const status = this.totalPricePerDay.find(
      (location) => location.companyName === companyName
    )?.availabilities.availabilityStatus;
    return !!status && SUSPENDED_LOCATION_AVAILABILITIES.includes(status);
  }

  private hasLocationWithAvailabilities(companyName: string): boolean {
    return this.locationsWithAvailabilities.some(
      (location) => location.companyName === companyName
    );
  }

  private subscribeToServerErrors(): void {
    this.catchServerError$.subscribe((result) => {
      if (!result) {
        return;
      }

      this.loading = false;
      this.store.dispatch(catchServerError({ serverError: null }));
    });
  }

  private initializeExistingVideoFile(): void {
    this.filename = this.ad.videoLink;

    if (!this.ad.videoLink) {
      return;
    }

    this.loadImage().subscribe((fileBlob) => {
      const existingVideoFile = new File(
        [fileBlob],
        this.translate.instant("campaignDetails.video") + "-" + this.ad.title,
        {
          type: fileBlob.type,
        }
      );
      this.files.push(existingVideoFile);
    });
  }

  private subscribeToUploadProgress(): void {
    this.uploadFile$.subscribe(
      (result: HttpEvent<any> | null | HttpResponse<{ filename: string }>) => {
        if (result?.type == HttpEventType.UploadProgress) {
          this.showProgress = true;
          const total = result?.total ?? 1;
          this.uploadProgress = Math.round((result.loaded / total) * 100);
          return;
        }

        if (result?.type != HttpEventType.Response) {
          return;
        }

        this.filename =
          (result as HttpResponse<{ filename: string }>)?.body?.filename ?? "";
        this.loading = false;
        this.store.dispatch(setFileName({ filename: null }));
        setTimeout(() => {
          this.showProgress = false;
        }, 2000);
      }
    );
  }

  private subscribeToUpdateResult(): void {
    this.update$.subscribe((result: SuccessDto | null) => {
      if (!result) {
        return;
      }

      this.isUpdateTotalHT = false;
      this.loading = false;
      this.store.dispatch(updateAdCampaignDetails({ successMessage: null }));
      this.close();
    });
  }

  private patchInitialFormValues(): void {
    this.form.patchValue({
      redirectionLink: this.ad.redirectionLink,
      formId: this.ad.formId,
      startDate: this.cloneDate(this.ad.startingDate),
      endDate: this.cloneDate(this.ad.endingDate),
    });
  }

  private buildUpdateCampaignPayload(
    totalHt: number | null
  ): CreateUpdateAdvertisingCampaignInterface {
    return {
      title: this.ad.title,
      startingDate: this.form.get("startDate")?.value,
      endingDate: this.form.get("endDate")?.value,
      redirectionLink: this.form.get("redirectionLink")?.value,
      status: this.ad.status,
      locationPartners: this.cloneLocationsWithAvailabilities(
        this.locationsWithAvailabilities
      ),
      objectiveName: this.ad.objectiveName,
      videoLink: this.filename,
      totalHt: totalHt,
      calculationMethod: this.ad.calculationMethod,
      estimateId: this.ad.estimateId,
      formId: this.form.get("formId")?.value,
      advertiserEmail: null,
    };
  }

  private buildCalculatePriceRequest(
    startDate: Date,
    endDate: Date,
    checkDates: boolean
  ): CalculatePrice {
    return {
      calculationMethod: this.ad.calculationMethod,
      startDate,
      endDate,
      objectiveName: this.ad.objectiveName,
      names: this.locationsWithAvailabilities.map(
        (location) => location.companyName
      ),
      checkDates,
    };
  }

  private getDateFromForm(controlName: "startDate" | "endDate"): Date {
    return new Date(this.form.get(controlName)?.value);
  }

  private isEndDateBeyondPreservedBoundary(endDate: Date): boolean {
    return (
      this.normalizeDates(endDate) >
      this.normalizeDates(this.originalEndDateReference)
    );
  }

  private isStartDateBeforePreservedBoundary(startDate: Date): boolean {
    return (
      this.normalizeDates(startDate) <
      this.normalizeDates(this.originalStartDateReference)
    );
  }

  private getExtendedEndDateStart(): Date {
    return this.shiftDate(this.originalEndDateReference, Constants.oneDay);
  }

  private getExtendedStartDateEnd(): Date {
    return this.shiftDate(this.originalStartDateReference, -Constants.oneDay);
  }

  private openAvailabilityModal(): NgbModalRef {
    return this.modalService.open(ListLocationPartnerAvailabilitiesComponent, {
      centered: true,
      backdrop: "static",
      keyboard: false,
    });
  }

  private handleAvailabilityModalSave(
    modal: NgbModalRef,
    value: LastAvailabilityUpdates
  ): void {
    modal.close();
    this.lastEndDateChosen = this.cloneDate(value.lastEndDateChosen);
    this.lastStartDateChosen = this.cloneDate(value.lastStartDateChosen);
    this.updatePreservedDateBoundaries(value);
    this.mergeAvailabilitiesWithIntervals(value.locationWithAvailability);
    this.refreshDisplayedLocationsWithAvailabilities();
  }

  private handleAvailabilityModalCancel(modal: NgbModalRef): void {
    modal.close();
    this.isModalOpen = false;
    this.patchFormDateValues(this.lastStartDateChosen, this.lastEndDateChosen);
  }

  private patchFormDateValues(startDate: Date, endDate: Date): void {
    this.form.patchValue({ endDate });
    this.form.patchValue({ startDate });
  }

  private updatePreservedDateBoundaries(
    value: LastAvailabilityUpdates
  ): void {
    this.preservedEndDateBoundary = new Date(
      Math.max(
        this.preservedEndDateBoundary.getTime(),
        new Date(value.lastEndDateChosen).getTime()
      )
    );
    this.preservedStartDateBoundary = new Date(
      Math.min(
        this.preservedStartDateBoundary.getTime(),
        new Date(value.lastStartDateChosen).getTime()
      )
    );
  }

  private cloneDateFilters(dateFilters: DateFilter[]): DateFilter[] {
    return (dateFilters ?? []).map((dateFilter) => ({
      startDate: this.cloneNullableDate(dateFilter.startDate),
      endDate: this.cloneNullableDate(dateFilter.endDate),
    }));
  }

  private cloneLocationsWithAvailabilities(
    locationsWithAvailabilities: LocationWithAvailabilities[]
  ): LocationWithAvailabilities[] {
    return (locationsWithAvailabilities ?? []).map((location) => ({
      companyName: location.companyName,
      listOfAvailableDates: this.cloneDateFilters(
        location.listOfAvailableDates
      ),
    }));
  }

  private syncOriginalLocationsWithAvailabilities(
    locationsWithAvailabilities: LocationWithAvailabilities[]
  ): void {
    this.originalLocationsWithAvailabilities =
      this.cloneLocationsWithAvailabilities(locationsWithAvailabilities);
  }

  private upsertOriginalLocationWithAvailabilities(
    locationWithAvailabilities: LocationWithAvailabilities
  ): void {
    const nextOriginalLocations = this.cloneLocationsWithAvailabilities(
      this.originalLocationsWithAvailabilities
    );
    const existingIndex = nextOriginalLocations.findIndex(
      (location) =>
        location.companyName === locationWithAvailabilities.companyName
    );
    const clonedLocation: LocationWithAvailabilities = {
      companyName: locationWithAvailabilities.companyName,
      listOfAvailableDates: this.cloneDateFilters(
        locationWithAvailabilities.listOfAvailableDates
      ),
    };

    if (existingIndex > -1) {
      nextOriginalLocations[existingIndex] = clonedLocation;
    } else {
      nextOriginalLocations.push(clonedLocation);
    }

    this.syncOriginalLocationsWithAvailabilities(nextOriginalLocations);
  }

  private updateOriginalLocationAndRefresh(
    locationWithAvailabilities: LocationWithAvailabilities
  ): void {
    this.upsertOriginalLocationWithAvailabilities(locationWithAvailabilities);
    this.refreshDisplayedLocationsWithAvailabilities();
  }

  private refreshDisplayedLocationsWithAvailabilities(): void {
    this.locationsWithAvailabilities =
      this.getConstrainedLocationsWithAvailabilities(
        this.originalLocationsWithAvailabilities,
        this.startDate,
        this.endDate
      );
    this.emitDatesAndAvailabilities(this.locationsWithAvailabilities);
  }

  private getConstrainedLocationsWithAvailabilities(
    locationsWithAvailabilities: LocationWithAvailabilities[],
    startDate: Date,
    endDate: Date
  ): LocationWithAvailabilities[] {
    if (!startDate || !endDate) {
      return this.cloneLocationsWithAvailabilities(locationsWithAvailabilities);
    }

    const campaignWindow = this.createCampaignWindow(startDate, endDate);

    return this.cloneLocationsWithAvailabilities(
      locationsWithAvailabilities
    ).map((availability) =>
      this.constrainLocationToCampaignWindow(
        availability,
        campaignWindow,
        startDate,
        endDate
      )
    );
  }

  private getDatesOutsideCurrentCampaignWindow(
    listOfAvailableDates: DateFilter[]
  ): DateFilter[] {
    if (!this.startDate || !this.endDate) {
      return this.cloneDateFilters(listOfAvailableDates);
    }

    const campaignWindow = this.createCampaignWindow(
      this.startDate,
      this.endDate
    );

    return this.cloneDateFilters(listOfAvailableDates).reduce<DateFilter[]>(
      (datesOutsideCurrentCampaign, dates) => [
        ...datesOutsideCurrentCampaign,
        ...this.extractDatesOutsideCampaignWindow(dates, campaignWindow),
      ],
      []
    );
  }

  private buildUpdatedLocationAvailabilities(
    newLocationWithAvailabilities: LocationWithAvailabilities
  ): LocationWithAvailabilities {
    return this.createLocationWithAvailabilities(
      newLocationWithAvailabilities.companyName,
      this.mergeOverlappingIntervals([
        ...this.getDatesOutsideCurrentCampaignWindow(
          this.getOriginalLocationDates(newLocationWithAvailabilities.companyName)
        ),
        ...this.cloneDateFilters(newLocationWithAvailabilities.listOfAvailableDates),
      ])
    );
  }

  private mergeAvailabilityIntoLocations(
    locations: LocationWithAvailabilities[],
    newItem: LocationWithAvailabilities
  ): LocationWithAvailabilities[] {
    const existingLocation = locations.find(
      (item) => item.companyName === newItem.companyName
    );
    const mergedLocation = this.createLocationWithAvailabilities(
      newItem.companyName,
      this.mergeOverlappingIntervals([
        ...(existingLocation?.listOfAvailableDates ?? []),
        ...this.cloneDateFilters(newItem.listOfAvailableDates),
      ])
    );

    if (!existingLocation) {
      return [...locations, mergedLocation];
    }

    return locations.map((location) =>
      location.companyName === newItem.companyName ? mergedLocation : location
    );
  }

  private createLocationWithAvailabilities(
    companyName: string,
    listOfAvailableDates: DateFilter[]
  ): LocationWithAvailabilities {
    return {
      companyName,
      listOfAvailableDates: this.cloneDateFilters(listOfAvailableDates),
    };
  }

  private getOriginalLocationDates(companyName: string): DateFilter[] {
    return this.getOriginalLocation(companyName)?.listOfAvailableDates ?? [];
  }

  private getOriginalLocation(
    companyName: string
  ): LocationWithAvailabilities | undefined {
    return this.originalLocationsWithAvailabilities.find(
      (location) => location.companyName === companyName
    );
  }

  private createCampaignWindow(
    startDate: Date,
    endDate: Date
  ): { start: number; end: number } {
    return {
      start: this.cloneDate(startDate).getTime(),
      end: this.cloneDate(endDate).getTime(),
    };
  }

  private constrainLocationToCampaignWindow(
    availability: LocationWithAvailabilities,
    campaignWindow: { start: number; end: number },
    startDate: Date,
    endDate: Date
  ): LocationWithAvailabilities {
    return {
      ...availability,
      listOfAvailableDates: availability.listOfAvailableDates
        .filter((dates) =>
          this.isDateFilterInsideCampaignWindow(dates, campaignWindow)
        )
        .map((dates) =>
          this.constrainDateFilterToCampaignWindow(
            dates,
            campaignWindow,
            startDate,
            endDate
          )
        ),
    };
  }

  private isDateFilterInsideCampaignWindow(
    dates: DateFilter,
    campaignWindow: { start: number; end: number }
  ): boolean {
    if (!dates.startDate || !dates.endDate) {
      return false;
    }

    const start = this.cloneDate(dates.startDate).getTime();
    const end = this.cloneDate(dates.endDate).getTime();

    return end >= campaignWindow.start && start <= campaignWindow.end;
  }

  private constrainDateFilterToCampaignWindow(
    dates: DateFilter,
    campaignWindow: { start: number; end: number },
    startDate: Date,
    endDate: Date
  ): DateFilter {
    const nextStartDate = dates.startDate
      ? this.cloneDate(dates.startDate).getTime() < campaignWindow.start
        ? this.cloneDate(startDate)
        : this.cloneDate(dates.startDate)
      : null;
    const nextEndDate = dates.endDate
      ? this.cloneDate(dates.endDate).getTime() > campaignWindow.end
        ? this.cloneDate(endDate)
        : this.cloneDate(dates.endDate)
      : null;

    return {
      startDate: nextStartDate,
      endDate: nextEndDate,
    };
  }

  private extractDatesOutsideCampaignWindow(
    dates: DateFilter,
    campaignWindow: { start: number; end: number }
  ): DateFilter[] {
    if (!dates.startDate || !dates.endDate) {
      return [];
    }

    const start = this.cloneDate(dates.startDate);
    const end = this.cloneDate(dates.endDate);

    if (
      end.getTime() < campaignWindow.start ||
      start.getTime() > campaignWindow.end
    ) {
      return [
        {
          startDate: start,
          endDate: end,
        },
      ];
    }

    const datesOutsideCurrentCampaign: DateFilter[] = [];

    if (start.getTime() < campaignWindow.start) {
      datesOutsideCurrentCampaign.push({
        startDate: start,
        endDate: this.shiftDate(new Date(campaignWindow.start), -Constants.oneDay),
      });
    }

    if (end.getTime() > campaignWindow.end) {
      datesOutsideCurrentCampaign.push({
        startDate: this.shiftDate(new Date(campaignWindow.end), Constants.oneDay),
        endDate: end,
      });
    }

    return datesOutsideCurrentCampaign;
  }

  private cloneDate(date: Date | string | number): Date {
    return new Date(date);
  }

  private cloneNullableDate(
    date: Date | string | number | null | undefined
  ): Date | null {
    return date ? this.cloneDate(date) : null;
  }

  private shiftDate(date: Date, offset: number): Date {
    return new Date(date.getTime() + offset);
  }
}
